// Created By Cursor — match templates to a school message service
export function buildServiceKeys(service) {
  const set = new Set()
  if (!service || service === 'all') return set
  const code = String(service.service_code || '').toLowerCase().trim()
  const group = String(service.group_name || '').toLowerCase().trim()
  const name = String(service.service_name || '').toLowerCase().trim()
  if (code) set.add(code)
  if (group) set.add(group)
  if (name) set.add(name)
  return set
}

// Created By Cursor
export function templateMatchesService(template, serviceKeys) {
  if (!serviceKeys || serviceKeys.size === 0) return true
  const g = String(template.group_name || '').toLowerCase().trim()
  const code = String(template.service_code || '').toLowerCase().trim()
  const name = String(template.name || '').toLowerCase().trim()
  if (code && serviceKeys.has(code)) return true
  if (g && serviceKeys.has(g)) return true
  for (const key of serviceKeys) {
    if (key && (g.includes(key) || name.includes(key) || key.includes(g))) {
      return true
    }
  }
  return false
}

// Created By Cursor
export function filterTemplatesByService(templates, service) {
  const list = Array.isArray(templates) ? templates : []
  if (!service || service === 'all') return list
  const keys = buildServiceKeys(service)
  if (!keys.size) return list
  return list.filter((t) => templateMatchesService(t, keys))
}

// Created By Cursor
export function formatTemplateName(name) {
  const raw = String(name || '').trim()
  if (!raw) return ''
  return raw
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase())
}

// Created By Cursor
export function formatVariableLabel(label) {
  return String(label || '')
    .replace(/[_-]+/g, ' ')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase())
}

// Created By Cursor — from variables_json or {{n}} placeholders in body
export function getTemplateVariables(template) {
  if (!template) return []

  let labels = []
  const raw = template.variables_json ?? template.variables
  if (Array.isArray(raw)) {
    labels = raw
  } else if (typeof raw === 'string' && raw.trim()) {
    try {
      const parsed = JSON.parse(raw)
      if (Array.isArray(parsed)) labels = parsed
    } catch (e) {
      labels = raw.split(',').map((v) => v.trim()).filter(Boolean)
    }
  }

  const body = template.body_text || template.body || template.message || ''
  const matches = [...String(body).matchAll(/\{\{(\d+)\}\}/g)]
  const indices = [...new Set(matches.map((m) => Number(m[1])))].sort((a, b) => a - b)

  if (indices.length) {
    return indices.map((n) => ({
      index: n,
      placeholder: `{{${n}}}`,
      label: labels[n - 1] ? String(labels[n - 1]) : '',
    }))
  }

  return labels.map((label, i) => ({
    index: i + 1,
    placeholder: `{{${i + 1}}}`,
    label: String(label),
  }))
}
